import {
  Add,
  Cable,
  CallMadeOutlined,
  CallReceivedOutlined,
  HistoryOutlined,
  HomeOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Box,
  Chip,
  Container,
  Grid,
  IconButton,
  ListItemDecorator,
  Stack,
  Tab,
  tabClasses,
  TabList,
  TabPanel,
  Tabs,
  Typography,
} from "@mui/joy";

import * as React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { CurrencyFormat } from "../config/services";
import Activity from "./activity";
import AssetItems from "./assetitems";
import HeaderMain from "../components/Headermain";
import { encodedurl } from "../App";

export default function HomeIndex() {
  const navigate = useNavigate();
  const userinfo = useSelector((state) => state.useInfos);
  const walletData = useSelector((state) => state.walletsData);
  const [showbalance, setSahowbalance] = React.useState(true);
  const [index, setIndex] = React.useState(0);

  return (
    <>
      <HeaderMain />
      <Container>
        <Grid
          container
          direction="column"
          spacing={2}
          sx={{ flexGrow: 1 }}
          mt={2}
        >
          <Grid>
            <Stack direction="column" spacing={1} alignItems={"flex-start"}>
              <Stack direction="column" spacing={0}>
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Typography level="title-sm">Available balance</Typography>
                  <IconButton
                    size="sm"
                    variant="plain"
                    color="neutral"
                    onClick={() => setSahowbalance(!showbalance)}
                  >
                    {showbalance ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </Stack>

                <Typography level="h1">
                  {showbalance ? (
                    <CurrencyFormat
                      amount={userinfo.totalBalance}
                      prefix={"$"}
                      seperator={true}
                    />
                  ) : (
                    "* * * *"
                  )}
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid mt={2}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {[
                {
                  title: "Send",
                  path: "/allcoin",
                  icon: <CallMadeOutlined fontSize="xl2" />,
                },
                {
                  title: "Receive",
                  path: "/receive",
                  icon: <CallReceivedOutlined fontSize="xl2" />,
                },
                { title: "Buy", path: "/buy", icon: <Add fontSize="xl2" /> },
              ].map((button, index) => (
                <Stack
                  key={index}
                  direction="column"
                  spacing={1}
                  alignItems="center"
                >
                  <IconButton
                    key={button.title}
                    variant="soft"
                    size="lg"
                    color="primary"
                    sx={{ width: "50px", height: "50px", borderRadius: "50px" }}
                    onClick={() => navigate(button.path)}
                  >
                    {button.icon}
                  </IconButton>
                  <Typography>{button.title}</Typography>
                </Stack>
              ))}

              <Stack direction="column" spacing={1} alignItems="center">
                <IconButton
                  variant="soft"
                  size="lg"
                  color="primary"
                  sx={{ width: "50px", height: "50px", borderRadius: "50px" }}
                  onClick={() => {
                    window.location.href = `http://localhost:3000/${encodedurl}`;
                  }}
                >
                  <Cable fontSize="xl2" />
                </IconButton>
                <Typography>Connect</Typography>
              </Stack>
            </Box>
          </Grid>

          <Grid mt={2}>
            <Tabs
              size="lg"
              sx={{ backgroundColor: "transparent" }}
              aria-label="Pipeline"
              value={index}
              onChange={(event, value) => setIndex(value)}
            >
              <TabList
                sx={{
                  pt: 1,
                  justifyContent: "center",
                  [`&& .${tabClasses.root}`]: {
                    flex: "initial",
                    bgcolor: "transparent",
                    "&:hover": {
                      bgcolor: "transparent",
                    },
                    [`&.${tabClasses.selected}`]: {
                      color: "primary.plainColor",
                      "&::after": {
                        height: 2,
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                        bgcolor: "primary.500",
                      },
                    },
                  },
                }}
              >
                <Tab indicatorInset>
                  <ListItemDecorator sx={{ fontSize: "larger" }}>
                    &#128176;
                  </ListItemDecorator>
                  Assets
                </Tab>

                <Tab indicatorInset>
                  <ListItemDecorator>
                    <HistoryOutlined />
                  </ListItemDecorator>
                  Activity
                </Tab>
              </TabList>
              <TabPanel sx={{ padding: 0, mt: 3 }} value={0}>
                <AssetItems />
              </TabPanel>
              <TabPanel value={1}>
                <Activity />
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
